import { permissonPaths, pathWithoutPermission } from '@/common/constant';

export function getPermissions(kerList) {
  try {
    if (localStorage.userInfo) {
      const userInfo = JSON.parse(localStorage.userInfo);
      const { permissions } = userInfo;
      const pathList = kerList.map(key => permissonPaths[key]);
      return pathList.reduce((map, path, index) => {
        map[kerList[index]] = hasPermission(permissions, path);
        return map;
      }, {});
    }
    return {};
  } catch (e) {
    console.log(e);
    return {};
  }
}

export function hasPermission(data, path) {
  if (data) {
    if (Array.isArray(data)) {
      return data.some(child => hasPermission(child, path));
    }
    if (data.fullPath === path) {
      return true;
    }
    if (data.children) {
      return hasPermission(data.children, path);
    }
  }
  return false;
}

export function createRandomString(length = 30) {
  const STRING = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const NUM = STRING.length;
  return new Array(length).fill(1).reduce(str => {
    let index = Math.floor(Math.random() * NUM);
    str = str + STRING.charAt(index);
    return str;
  }, '');
}

export function pathPermission(permissions, pathTo) {
  let flag = false;
  // 如果结尾有/则删除
  if (pathTo.slice(-1) === '/' && pathTo !== '/') {
    pathTo = pathTo.slice(0, -1);
  }
  // pdfview有type
  let strPdf = /^\/pdfview.*/;
  if (pathWithoutPermission.indexOf(pathTo) > -1 || strPdf.test(pathTo)) {
    flag = true;
  } else {
    flag = hasPermission(permissions, pathTo);
  }
  return flag;
}
export const getAppId = () => {
  let appId;
  if (window.location.host === 'hubble.sourcecodecap.com:8050') {
    appId = 'cli_a2944d3d4c22900e';
  } else if (/hubble/.test(window.location.host)) {
    appId = 'cli_9f8f27b375fbd00c';
  } else if (/pretianchi/.test(window.location.host)) {
    appId = 'cli_a13c47f49878900b';
  } else if (/tianchi/.test(window.location.host)) {
    appId = 'cli_9e32766f10b9900e';
  } else {
    appId = 'cli_9f8f27b375fbd00c';
  }
  return appId;
};
